import React, { Component }     from 'react';
import { withRouter }           from 'react-router';
import { connect }              from 'react-redux';
import { ModalManager, Effect } from 'react-dynamic-modal';
import { MdAdd }                from 'react-icons/md';
import { PubSubConstants }      from '../environment';
import DynamicModal             from '../../../Modal';
import { addFetchData }         from '../../../../actions/pubsub/add';

var apiHost = PubSubConstants.WebApiHost;

class ListAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      process  : '',
      event    : '',
      owner    : '',
      disabled : false
    };

    this.add            = this.add.bind(this);
    this.openModal      = this.openModal.bind(this);
    this.handleSubmit   = this.handleSubmit.bind(this);
    this.updateProcess  = this.updateProcess.bind(this);
    this.updateEvent    = this.updateEvent.bind(this);
    this.updateOwner    = this.updateOwner.bind(this);
    this.updateDisabled = this.updateDisabled.bind(this);
  }
  
  add() {
    var params = {
      process: this.state.process,
      event: this.state.event,
      owner: this.state.owner,
      disabled: this.state.disabled
    };
    
    this.props.fetchData(apiHost, params);
  }

  openModal() {
    let content =
      <div>
        <form onSubmit={this.handleSubmit}>
          <label>
            <span style={{ marginRight: '2px' }}>Process</span>
            <input type='text' name='process' onChange={evt => this.updateProcess(evt)} />
          </label>
          <label>
            <span style={{ marginRight: '2px' }}>Event</span>
            <input type='text' name='event' onChange={evt => this.updateEvent(evt)} />
          </label>
          <label>
            <span style={{ marginRight: '2px' }}>Owner</span>
            <input type='text' name='owner' onChange={evt => this.updateOwner(evt)} />
          </label>
          <label>
            <span style={{ marginRight: '5px' }}>Disabled?</span>
            <input style={{ margin: '4px 0 0' }} type='checkbox' name='disabled' onChange={evt => this.updateDisabled(evt)} />
          </label>
        </form>
      </div>;
        
    ModalManager.open(
      <DynamicModal content={content} effect={Effect.ScaleUp} ok={this.add} title={'Add Process Mapping'} />
    );
  }

  handleSubmit(event) {
    if (this.state.process && this.state.event && this.state.owner) {
      this.add();
    }

    event.preventDefault();
  }

  updateProcess(event) {
    this.setState({ process: event.target.value });
  }

  updateEvent(event) {
    this.setState({ event: event.target.value });
  }

  updateOwner(event) {
    this.setState( { owner: event.target.value });
  }

  updateDisabled(event) {
    this.setState({ disabled: event.target.checked });
  }

  render() {
    return (
      <div style={{ float: 'right', marginRight: '50px' }}>
        <button onClick={this.openModal}>
          <MdAdd size={24} />
        </button>
      </div>
      );
    }
}

const mapStateToProps = state => {
  return {
    add: state.pubsub.add.add,
    hasErrored: state.pubsub.add.addHasErrored,
    isLoading: state.pubsub.add.addIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, params) => dispatch(addFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListAdd));
